/**
 * Formats a title for referral by removing trailing punctuation and converting specific phrases to lowercase.
 * @param title The title to format
 * @returns The formatted title
 */
export const formatTitleForReferral = (
  title: string | null | undefined
): string | null | undefined => {
  if (!title) return title;

  // Remove trailing punctuation
  let formattedTitle = title.replace(/[.!?]+$/, "");

  // Convert specific phrases to lowercase
  if (formattedTitle.match(/\bOff Any Service$/i)) {
    formattedTitle = formattedTitle.replace(
      /Off Any Service$/i,
      "off any service"
    );
  }
  if (formattedTitle.match(/\bTowards Any Service$/i)) {
    formattedTitle = formattedTitle.replace(
      /Towards Any Service$/i,
      "towards any service"
    );
  }
  if (formattedTitle.match(/\bOff Any Treatment$/i)) {
    formattedTitle = formattedTitle.replace(
      /Off Any Treatment$/i,
      "off any treatment"
    );
  }
  if (formattedTitle.match(/\bTowards Any Treatment$/i)) {
    formattedTitle = formattedTitle.replace(
      /Towards Any Treatment$/i,
      "towards any treatment"
    );
  }

  return formattedTitle;
};

/**
 * Formats a platform name for referral by removing "Rewards" suffix (case-insensitive).
 * @param platformName The platform name to format
 * @returns The formatted platform name
 */
export const formatPlatformNameForReferral = (
  platformName: string | null | undefined
): string | null | undefined => {
  if (!platformName) return platformName;

  // Remove "Rewards" suffix (case-insensitive)
  return platformName.replace(/(\s+|^)rewards$/i, "").trim();
};
